var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5631 11.5871C34.7822 18.4277 32.2857 26.1059 26.4606 30.2941C20.6354 34.6218 12.7299 34.6218 6.9048 30.2941C1.07967 25.9663 -1.41681 18.4277 0.802286 11.5871C3.16007 4.60693 9.53997 0 16.752 0C23.9641 0 30.344 4.60693 32.5631 11.5871ZM16.752 1.53564C10.2334 1.53564 4.40832 5.72376 2.32791 12.0059C0.247512 18.2881 2.46661 25.1287 7.87565 29.0376C13.146 32.9465 20.3581 32.9465 25.6284 29.0376C30.8988 25.1287 33.1179 18.2881 31.1761 12.0059C29.0957 5.72376 23.2706 1.53564 16.752 1.53564Z",
    fill: "#7E7E7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9712 11.8663C19.3872 11.8663 19.8033 11.8663 20.3581 11.8663H20.4968V9.49306C20.2194 9.49306 19.942 9.49306 19.8033 9.35345C19.3872 9.35345 18.8325 9.35345 18.4164 9.35345C17.7229 9.35345 17.0295 9.49306 16.4747 9.91187C15.7812 10.6099 15.3651 11.1683 15.2264 12.0059C15.2264 12.2851 15.0877 12.704 15.0877 12.9832C15.0877 13.5416 15.0877 14.1 15.0877 14.5188V14.6584H12.8687V17.3109H15.0877V23.8723H17.8616V17.3109H20.0807C20.2194 16.4733 20.3581 15.496 20.3581 14.6584C20.2194 14.6584 20.0807 14.6584 19.8033 14.6584C19.1099 14.6584 17.7229 14.6584 17.7229 14.6584C17.7229 14.6584 17.7229 13.402 17.7229 12.8436C17.8616 12.1455 18.4164 12.0059 18.9712 11.8663Z",
    fill: "#7E7E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookBlack);
export default __webpack_public_path__ + "static/media/facebookBlack.df6e0a54241bc6df7c0755d04e6e81fb.svg";
export { ForwardRef as ReactComponent };